var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-category-section" },
    [
      _c("h2", { staticClass: "c-category-section__title" }, [
        _vm._v("\n    " + _vm._s(_vm.optionCategory.name) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.extraInfo
        ? _c(
            "button",
            {
              staticClass: "c-btn c-btn--invisible u-margin-bottom",
              on: { click: _vm.toggleModal }
            },
            [_vm._v("\n    " + _vm._s(_vm.optionCategory.description) + "\n  ")]
          )
        : _c("p", [
            _vm._v("\n    " + _vm._s(_vm.optionCategory.description) + "\n  ")
          ]),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            { staticClass: "c-modal--narrow", on: { close: _vm.toggleModal } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.optionCategory.longTitle))]),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.optionCategory.longDescription)
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c("OptionComponent", {
          key: option.id,
          attrs: { optionId: option.id, residenceId: _vm.residenceId }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }